import React from "react";
import { Alert, Button } from "reactstrap";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { ControversiaCurpStore } from "../../../containers/personaReferencia/controversiaCurp/ControversiaCurp.store";
import { ControversiaCurpDispatcher } from "../../../containers/personaReferencia/controversiaCurp/ControversiaCurp.dispatcher";

interface Props extends ControversiaCurpStore, ControversiaCurpDispatcher {
  idPersonaCurp: number;
  idPersonaSolicitante?: number;
  onSuccess: () => void;
}

interface State {}

class ControversiaCurpComponent extends React.Component<Props, State> {
  state = {};

  async componentDidMount() {
    const preview = await this.props.getControversiaCurp(
      this.props.idPersonaCurp,
      this.props.idPersonaSolicitante
    );

    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingControversiaCurpError ||
          "No se pudo verificar si el CURP se puede liberar"
      );
    }
  }

  componentWillUnmount() {
    this.props.clearPersonaReferencia();
  }

  handleLiberarCurp = async () => {
    const { idPersonaCurp, idPersonaSolicitante, putLiberarCurp } = this.props;
    const preview = await putLiberarCurp(idPersonaCurp, idPersonaSolicitante);

    if (preview.fulfilled) {
      successNotification("CURP liberada exitosamente");
      this.props.onSuccess();
    } else {
      errorNotification(
        preview.puttingLiberarCurpError || "Error al liberar CURP"
      );
    }
  };

  render() {
    const {
      controversiaCurp,
      gettingControversiaCurp,
      puttingLiberarCurp
    } = this.props;

    return (
      <div className="container-fluid">
        {/* Loading */}
        {gettingControversiaCurp && (
          <div className="text-center py-5">
            {/* <Spinner color="primary" /> */}
            <p className="mt-3">Consultando información...</p>
          </div>
        )}

        {/* Success State */}
        {controversiaCurp && (
          <div>
            {/* Información de la Persona */}
            <div className="mb-4">
              <h5>Información de la Persona</h5>
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <th style={{ width: "200px" }}>ID Persona:</th>
                    <td>{controversiaCurp.idPersona}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "200px" }}>Nombre:</th>
                    <td>{controversiaCurp.nombreCompleto}</td>
                  </tr>
                  <tr>
                    <th>CURP:</th>
                    <td>{controversiaCurp.curp || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Tipo:</th>
                    <td>{controversiaCurp.tipo}</td>
                  </tr>
                  <tr>
                    <th>TotalPass:</th>
                    <td>
                      {controversiaCurp.totalPass ? (
                        <span className="badge badge-info">Sí</span>
                      ) : (
                        <span className="badge badge-secondary">No</span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Contadores */}
            <div className="mb-4">
              <h5>Contadores de Referencias</h5>
              <div className="row">
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6>Titular</h6>
                      <h3>{controversiaCurp.titularCount > 0 ? "Sí" : "No"}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6>Propietario</h6>
                      <h3>
                        {controversiaCurp.propietarioCount > 0 ? "Sí" : "No"}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6>Invitado</h6>
                      <h3>
                        {controversiaCurp.invitadoCount > 0 ? "Sí" : "No"}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6>Facturas</h6>
                      <h3>{controversiaCurp.ventasCount}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Resolución */}
            <div className="mb-4">
              <h5>Resolución</h5>
              {controversiaCurp.resolucion ? (
                <Alert color="success">
                  <i className="fa fa-check-circle mr-2"></i>
                  <strong>La persona puede ser liberada</strong>
                </Alert>
              ) : (
                <Alert color="danger">
                  <i className="fa fa-times-circle mr-2"></i>
                  <strong>La persona NO puede ser liberada</strong>
                </Alert>
              )}
            </div>

            {/* Razones No Liberable */}
            {controversiaCurp.razonesNoLiberable &&
              controversiaCurp.razonesNoLiberable.length > 0 && (
                <div className="mb-4">
                  <h5>Razones por las que NO se puede liberar:</h5>
                  {controversiaCurp.razonesNoLiberable.map(
                    (razon: string, index: number) => (
                      <Alert key={index} color="danger">
                        {razon}
                      </Alert>
                    )
                  )}
                </div>
              )}

            {/* Acciones */}
            <div className="text-right">
              {controversiaCurp.resolucion && (
                <Button
                  color="primary"
                  onClick={this.handleLiberarCurp}
                  disabled={puttingLiberarCurp}
                >
                  {puttingLiberarCurp ? <>Liberando...</> : <>Liberar CURP</>}
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ControversiaCurpComponent;
